var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFileCopy48Line = function SvgIconFileCopy48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.17 21.169c-.03-.15-.08-.28-.15-.41-.02-.03-.03-.07-.05-.1-.07-.13-.16-.25-.27-.36l-6-6c-.11-.11-.23-.19-.36-.27-.03-.02-.06-.03-.09-.05-.23-.11-.48-.18-.75-.18h-9.4a5.31 5.31 0 0 0-5.3 5.3v15.8c0 2.92 2.38 5.3 5.3 5.3h11.8c2.92 0 5.3-2.38 5.3-5.3v-13.4c0-.11-.01-.22-.03-.33Zm-5.27 15.63H21.1a1.9 1.9 0 0 1-1.9-1.9v-15.8c0-1.05.85-1.9 1.9-1.9h7.7v3.1c0 1.6 1.3 2.9 2.9 2.9h3.1v11.7a1.9 1.9 0 0 1-1.9 1.9Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 7.799H15.1a5.31 5.31 0 0 0-5.3 5.3v19.4h3.4v-19.4c0-1.05.85-1.9 1.9-1.9h15.4v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconFileCopy48Line;